export default {
  REQUEST_ICONS(state) {
    state.status = "fetching";
  },
  SUCCESS_REQUEST_ICONS(state, res) {
    state.status = "success";
    state.Icons = res.body;
  },
  FAILURE_REQUEST_ICONS(state) {
    state.status = "failure";
  },
  REQUEST_CREATE_ICON(state) {
    state.status = "creating";
  },
  SUCCESS_REQUEST_CREATE_ICON(state, res) {
    state.status = "success";
    state.Icons.push(res.body);
  },
  FAILURE_REQUEST_CREATE_ICON(state) {
    state.status = "failure";
  },
  REQUEST_UPDATE_ICON(state) {
    state.status = "updating";
  },
  SUCCESS_REQUEST_UPDATE_ICON(state, res) {
    state.status = "success";
    const index = state.Icons.findIndex(i => i._id === res.body._id);
    if (index !== -1) {
      state.Icons.splice(index, 1, res.body);
    }
  },
  FAILURE_REQUEST_UPDATE_ICON(state) {
    state.status = "failure";
  },
  REQUEST_DELETE_ICON(state) {
    state.status = "deleting";
  },
  SUCCESS_REQUEST_DELETE_ICON(state) {
    state.status = "success";
  },
  FAILURE_REQUEST_DELETE_ICON(state) {
    state.status = "failure";
  }
};
